import { apiClient, ApiResponse } from "@/shared/api";

interface UpdateUserPayload {
  firstName?: string;
  lastName?: string;
  phone?: string;
  photo?: string;
  password?: string;
  oldPassword?: string;
  newPassword?: string;
}

export const updateUser = (
  payload: UpdateUserPayload
): Promise<ApiResponse<undefined>> => {
  return apiClient(`/api/users`, "put", payload);
};